export default __webpack_public_path__ + "locales/lv/InfoPanel.json?hash=4f4537dddfc77fb0746e1e330c536592";